export const ScenariosConstants = {
	DEFAULT_AUM: 100000
};
